/**
 * Normalize Instantly GET /campaigns (v2) responses: array, or { items | data | campaigns }.
 */
export function normalizeInstantlyCampaignList(response) {
  if (response == null) return [];
  const raw = Array.isArray(response)
    ? response
    : response.items ?? response.data ?? response.campaigns ?? [];
  if (!Array.isArray(raw)) return [];
  return raw
    .map((r) => {
      if (!r || typeof r !== "object") return null;
      const id = r.id != null ? String(r.id) : r.campaign_id != null ? String(r.campaign_id) : "";
      if (!id) return null;
      const nameRaw = r.name != null ? String(r.name).trim() : "";
      const name = nameRaw || `Campaign ${id.slice(0, 8)}`;
      return { id, name };
    })
    .filter(Boolean);
}

/**
 * Resolve campaign UUID from dropdown selection (prefer id; fallback to name match for legacy state).
 * @param {string} selected - option value (usually campaign id)
 * @param {unknown} campaignsRes - raw API response from list campaigns
 * @returns {string | null}
 */
export function resolveInstantlyCampaignId(selected, campaignsRes) {
  if (selected == null || String(selected).trim() === "") return null;
  const rows = normalizeInstantlyCampaignList(campaignsRes);
  const s = String(selected).trim();
  const byId = rows.find((r) => r.id === s);
  if (byId) return byId.id;
  const byName = rows.find((r) => r.name.trim() === s);
  return byName?.id ?? null;
}
